import { Locale } from '@/helpers/languages';

export const SEO_CACHE_TTL =
  process.env.NEXT_PUBLIC_APP_ENV === 'development' ? 0 : 60 * 60; // 1h

export const getLocalizedPath = (locale: string, path: string): string => {
  if (!locale || locale === Locale.ENGLISH) {
    return path ? path : '/';
  }
  if (!path) {
    return `/${locale}`;
  }
  const pathSegments = [locale];
  pathSegments.push(path.startsWith('/') ? path.substring(1) : path);
  return `/${pathSegments.join('/')}`;
};
